
import React from 'react';
import { Button } from '@/components/ui/button';

interface NoGuestSelectedProps {
  onBack: () => void;
}

export const NoGuestSelected = ({ onBack }: NoGuestSelectedProps) => {
  return (
    <div className="text-center p-6">
      <p className="text-muted-foreground">Please select a guest first.</p>
      <Button onClick={onBack} className="mt-4">
        Go Back
      </Button>
    </div>
  );
};
